import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { UI_ROUTES } from "src/app/app.contant";
import { Tab } from "../models";
import { Location } from '@angular/common';
import { AuthService } from "../../core/services/auth/auth.service";

@Injectable({
  providedIn: 'root',
})
export class TabService {

  public tabs : Array<Tab<any>> = [];
  private _tabSub = new BehaviorSubject<Array<Tab<any>>>(this.tabs);

  private data = new BehaviorSubject("")
  currentData = this.data.asObservable();

  constructor(private router: Router, private location : Location, private _authService:AuthService) {
  }

  public setData(data: any) {
    this.data.next(data);
  }

  public tabSubscription<T>() : Observable<Array<Tab<T>>> {
    return this._tabSub.asObservable()
  }

  public removeTab(index: number) {
    this.tabs.splice(index, 1);
    if (this.tabs.length > 0) {
      this.tabs[this.tabs.length - 1].active = true;
    }
    this._tabSub.next(this.tabs);
  }

  public addTab<T>(tab: Tab<T>) : void {
    tab.id = this.tabs.length + 1;
    // this.tabs.forEach(element => { element.active = false });
    this.tabs.push(tab);
    this._tabSub.next(this.tabs);
    if(this.tabs.length) {
      this.tabs[0].active = true;
    }
  }

  public updateTabStatus(tabIndex : number) {
    this.tabs.forEach(element => { element.active = false });
    this.tabs[tabIndex].active = true;
    this._tabSub.next(this.tabs);
  }

  public clearTabs() : void {
    this.tabs = [];
    this._tabSub.next(this.tabs);
  }

  public backToHome(){
    if(this._authService.getUserRole() !== 'FACTORY_PROCUREMENT'&& this._authService.getUserRole() !=='REPORTING_MANAGER'){
      this.router.navigateByUrl(UI_ROUTES.HOME,{state:{selectedTab:1}})
    } else{
      this.router.navigateByUrl(UI_ROUTES.HOME,{state:{selectedTab:0}})
    }
  }

  public goBack(){
    this.location.back();
  }
}
